import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { handleAxiosNetworkError, handleResponse200 } from "../../utils/HttpUtils";
import { notifyError } from "../../utils/Notification";
import { isPhone } from "../../utils/PlatformHelper";
import { getUnverifiedTransferReceipt } from "./Api";

const UnverifiedReceipt = ({
  isRefetchData,
  onFinishRefetchData
}) => {
  const navigate = useNavigate()

  const { screenSize } = useSelector(state => state.global)
  
  const [unverifiedLst, setUnverifiedLst] = useState([])

  useEffect(() => {
    if (!isRefetchData) return;

    getUnverifiedTransferReceipt()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            setUnverifiedLst(payload)
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => {
        onFinishRefetchData()
      })
      
  }, [isRefetchData])

  function buktiStatusToLabel(status) {
    if (status === 'bukti_pending') {
      return "Belum Diverifikasi"
    }
    else if (status === 'bukti_invalid') {
      return "Tidak Valid"
    }
    else {
      return "Valid"
    }
  }

  if (unverifiedLst.length === 0) return null;  

  return (
    <div
      className="py-5 border-t border-b"
    >
      <div 
        className="text-center font-bold"
        style={{
          fontFamily: 'Nunito',
          fontSize: '18px'
        }}
      >
        Catatan Unggah Bukti Transfer
      </div>
      <div className="flex justify-center px-5">
        <div
          className={
            "space-y-3 py-3 " +
            (isPhone(screenSize.width) ? " w-full " : " w-2/3 ")
          }
          style={{
            fontSize: '14px'
          }}
        >
          {unverifiedLst.map(ud => (
            <div
              className="p-3 rounded-md border space-y-1"
            >
              <div
                className="flex space-x-2"
              >
                <div className="w-24">Tgl Unggah</div>
                <div>:</div>
                <div>{ud.createdAt}</div>
              </div>
              <div
                className="flex space-x-2"
              >
                <div className="w-24">Status</div>
                <div>:</div>
                <div>
                  <label
                    className={
                      "p-1 px-3 rounded-full text-white " +
                      (ud.status === 'bukti_pending' ? 'bg-blue-500' : ud.status === 'bukti_invalid' ? 'bg-red-500' : 'bg-green-500')
                    }
                  >
                    {buktiStatusToLabel(ud.status)}
                  </label>
                </div>
              </div>
              <div
                className="pt-3"
              >
                <button
                  className="p-1.5 px-5 bg-blue-500 text-white rounded-md"
                  style={{
                    fontSize: '14px'
                  }}
                  onClick={() => window.open(ud.file, "_blank")}
                >
                  Lihat Berkas 
                </button>
              </div>
            </div>
          ))} 
        </div>
      </div>
    </div>
  )

}

export default UnverifiedReceipt;